import script from "./wanchenglinshi.vue?vue&type=script&setup=true&lang=js"
export * from "./wanchenglinshi.vue?vue&type=script&setup=true&lang=js"

import "./wanchenglinshi.vue?vue&type=style&index=0&id=f1f310e6&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1f310e6"]])

export default __exports__